module.exports = __webpack_public_path__ + "img/jr34.6d32d715.jpg";